import useAction from "./useAction";

const LABEL_SCHEDULE_DELETED = "Schedule is deleted";

type Props = {
  scheduleId?: string;
  deleteSchedule: (scheduleId: string) => Promise<unknown>;
  onClose: () => void;
};

const useDelete = ({
  scheduleId,
  deleteSchedule,
  onClose,
}: Props) => {
  const { onAction: onDeleteSchedule, isLoading } = useAction({
    scheduleId,
    action: deleteSchedule,
    successMessage: LABEL_SCHEDULE_DELETED,
    onSuccess: onClose,
  });

  return { onDeleteSchedule, isLoading };
};

export default useDelete;
